module.exports = __webpack_public_path__ + "static/rentohetki-8d89b85a1b6d487551331a5a481dbe0b.jpg";